<template>
  <v-container fluid grid-list-md>
    <v-card class="mb-2">
      <v-card-title>
        <span class="headline mb-0">船社別フリータイム詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save()" :disabled="!valid">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-form v-model="valid">
      <v-layout row style="margin-top: 24px !important" wrap>
        <v-flex md12 sm3 style="padding: 0px !important; padding-right: 10px">
          <v-card>
            <v-card-text>
              <v-container fluid style="padding: 17px !important">
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <remote-autocomplete
                      label="船社・航空会社"
                      url="companies/forwarders/kv"
                      v-model="form.forwarderId"
                    ></remote-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-select
                      label="基準日"
                      disabled
                      :items="['ETA']"
                      clearable
                      v-model="form.standard"
                    ></v-select>
                  </v-flex>
                  <v-flex md6 xs12>
                    <remote-autocomplete
                      label="積出港"
                      :multiple="true"
                      url="ports/kv"
                      v-model="form.loadingPorts"
                    ></remote-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <remote-autocomplete
                      label="除外積出港"
                      :multiple="true"
                      url="ports/kv"
                      v-model="form.exceptLoadingPorts"
                    ></remote-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <remote-autocomplete
                      label="陸揚港"
                      :multiple="true"
                      url="ports/kv"
                      v-model="form.dischargePorts"
                    ></remote-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <remote-autocomplete
                      label="除外陸揚港"
                      :multiple="true"
                      url="ports/kv"
                      v-model="form.exceptDischargePorts"
                    ></remote-autocomplete>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      type="number"
                      clearable
                      label="freeDays"
                      v-model="form.freeDays"
                    />
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-select
                      label="日数カウント"
                      :items="['CALENDAR', 'WORKING']"
                      clearable
                      v-model="form.freeDaysType"
                    ></v-select>
                  </v-flex>

                  <v-flex md6 xs12>
                    <v-text-field
                      clearable
                      label="備考"
                      v-model="form.remark"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import RemoteAutocomplete from '../../components/RemoteAutocomplete.vue'
import Calendar from '../../views/M0091/Calendar'

/* eslint-disable no-console */
export default {
  components: { Calendar },

  data() {
    return {
      valid: false,
      form: {
        loadingPorts: [],
        exceptLoadingPorts: [],
        dischargePorts: [],
        exceptDischargePorts: [],
        standard: 'ETA',
      },
    }
  },
  methods: {
    save() {
      this.dealData()
      this.$http
        .post(`/free-days`, this.form)
        .then(() => {
          this.$router.go(-1)
          this.$message('', 'FreeDays保存しました。')
        })
        .catch(() => {
          this.$message('', 'FreeDays保存できません。')
        })
    },
    dealData() {
      this.form = {
        ...this.form,
        freeDaysPortVos: [
          ...[
            ...this.form.loadingPorts.map((portCode) => ({
              portCode: portCode,
              portType: 'LOADING_PORT',
            })),
            ...this.form.exceptLoadingPorts.map((portCode) => ({
              portCode: portCode,
              portType: 'EXCEPT_LOADING_PORT',
            })),
            ...this.form.dischargePorts.map((portCode) => ({
              portCode: portCode,
              portType: 'DISCHARGE_PORT',
            })),
            ...this.form.exceptDischargePorts.map((portCode) => ({
              portCode: portCode,
              portType: 'EXCEPT_DISCHARGE_PORT',
            })),
          ],
        ],
      }
    },
  },
  watch: {
    'form.loadingPorts'() {
      if (this.form.loadingPorts.length > 0) {
        this.$set(this.form, 'exceptLoadingPorts', [])
      }
    },
    'form.exceptLoadingPorts'() {
      if (this.form.exceptLoadingPorts.length > 0) {
        this.$set(this.form, 'loadingPorts', [])
      }
    },
    'form.dischargePorts'() {
      if (this.form.dischargePorts.length > 0) {
        this.$set(this.form, 'exceptDischargePorts', [])
      }
    },
    'form.exceptDischargePorts'() {
      if (this.form.exceptDischargePorts.length > 0) {
        this.$set(this.form, 'dischargePorts', [])
      }
    },
  },
}
</script>
